import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './NotFound.css';

const NotFound = ({ user }) => {
    const navigate = useNavigate();

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (user) {
                navigate("/home");
            } else {
                navigate("/login");
            }
        }, 8000);
        return () => clearTimeout(timeout);
    }, [navigate, user]);

    return (
        <div className="not-found-container">
                <div className="not-found-alert">
                    <h1>404 - Página no encontrada</h1>
                    <p className="not-found-message">
                        Lo sentimos, no hemos podido encontrar la página que estás buscando.
                    </p>
                </div>
        </div>
    );
};

export default NotFound;
